export default (state, componentId, accountId) => {
	const newState = state.map((account) => {
		if (accountId === account.id) {
			return {...account, relatedComponents: account.relatedComponents.filter((item) => item !== componentId)};
		}
		return account;
	});

	return newState;
};
